import React from 'react';
import { getNumberString } from '../../utils/numbers';
export const NumberString = ({ value }) => {
    return React.createElement(React.Fragment, null, getNumberString(value));
};
